import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=fccb8534&scoped=true"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemDropdown.vue?vue&type=style&index=0&id=fccb8534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccb8534",
  null
  
)

export default component.exports